import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import validator from 'validator';
import { Row, Cell } from 'sarsaparilla';
import { HolderInfoProps, PassTypeProps } from '../props';
import { TextInput, EmailInput } from '../../../ui-lottery/src/components/inputs';

const propTypes = {
  holderInfo: HolderInfoProps.isRequired,
  passType: PassTypeProps.isRequired,
  onChange: PropTypes.func.isRequired
};

export default class HolderInfoForm extends PureComponent {
  constructor(props) {
    super(props);

    const { holderInfo } = this.props;

    this.state = {
      confirmation: holderInfo.email,
      firstNameIsValid: !this.validateFirstName(holderInfo.first_name),
      lastNameIsValid: !this.validateLastName(holderInfo.last_name),
      emailIsValid: !this.validateEmail(holderInfo.email),
      confirmationIsValid: !this.validateEmail(holderInfo.email)

    };

    this.onFirstNameChanged = this.onFirstNameChanged.bind(this);
    this.onLastNameChanged = this.onLastNameChanged.bind(this);
    this.onEmailChanged = this.onEmailChanged.bind(this);
    this.onEmailConfirmationChanged = this.onEmailConfirmationChanged.bind(this);

    this.validateFirstName = this.validateFirstName.bind(this);
    this.validateLastName = this.validateLastName.bind(this);
    this.confirmEmail = this.confirmEmail.bind(this);
  }

  componentDidMount() {
    this.props.onChange(this.props.holderInfo, this.formIsValid());
  }

  componentWillUnmount() {
    this.props.onChange(this.props.holderInfo, true);
  }

  onFirstNameChanged(firstName, firstNameIsValid) {
    const { holderInfo } = this.props;

    this.setState((prevState) => ({ ...prevState, firstNameIsValid }), () => {
      this.props.onChange({ ...holderInfo, first_name: firstName }, this.formIsValid());
    });
  }

  onLastNameChanged(lastName, lastNameIsValid) {
    const { holderInfo } = this.props;

    this.setState((prevState) => ({ ...prevState, lastNameIsValid }), () => {
      this.props.onChange({ ...holderInfo, last_name: lastName }, this.formIsValid());
    });
  }

  onEmailChanged(email, emailIsValid) {
    const { holderInfo } = this.props;

    this.setState((prevState) => ({ ...prevState, emailIsValid }), () => {
      this.props.onChange({ ...holderInfo, email }, this.formIsValid());
    });
  }

  onEmailConfirmationChanged(confirmation, confirmationIsValid) {
    const { holderInfo } = this.props;

    this.setState((prevState) => ({ ...prevState, confirmation, confirmationIsValid }), () => {
      this.props.onChange(holderInfo, this.formIsValid());
    });
  }

  formIsValid() {
    const { firstNameIsValid, lastNameIsValid, emailIsValid, confirmationIsValid } = this.state;

    return firstNameIsValid && lastNameIsValid && emailIsValid && confirmationIsValid;
  }

  validateFirstName(value) {
    return value === '' && 'Please provide a first name';
  }

  validateLastName(value) {
    return value === '' && 'Please provide a last name';
  }

  validateEmail(value) {
    return !validator.isEmail(value) && 'Please provide a valid email address';
  }

  confirmEmail(value) {
    const { email } = this.props.holderInfo;
    return value !== email && 'Email and confirmation do not match';
  }

  render() {
    const { passType, holderInfo } = this.props;
    const { confirmation } = this.state;

    if (passType.features.indexOf('holder-info') === -1) {
      return null;
    }

    return (
      <div>
        <Row>
          <Cell width={6}>
            <TextInput
              label="First Name"
              id={'holder-first-name'}
              value={holderInfo.first_name}
              required
              validator={this.validateFirstName}
              onChange={this.onFirstNameChanged} />
          </Cell>
          <Cell width={6}>
            <TextInput
              label="Last Name"
              id={'holder-last-name'}
              value={holderInfo.last_name}
              required
              validator={this.validateLastName}
              onChange={this.onLastNameChanged} />
          </Cell>
        </Row>
        <Row>
          <Cell width={6}>
            <EmailInput
              label="Visitor Email Address"
              id={'holder-email'}
              value={holderInfo.email}
              required
              onChange={this.onEmailChanged} />
          </Cell>
          <Cell width={6}>
            <TextInput
              label="Re-Enter Visitor Email Address"
              id={'holder-email-confirmation'}
              value={confirmation}
              required
              validator={this.confirmEmail}
              onChange={this.onEmailConfirmationChanged} />
          </Cell>
        </Row>
      </div>
    );
  }
}

HolderInfoForm.propTypes = propTypes;
